import { KiteIcon } from '@kite/react-kite';
import React from 'react';
import './QuizCard.scss';

export interface QuizCardProps {
    title: string;
    mainHeading: string;
    first?: boolean;
    last?: boolean;
    step: number;
    id: string;
    children: React.ReactElement;
    valid: boolean;
    setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
    style?: React.CSSProperties;
}

export const QuizCard = (props: QuizCardProps) => {
    return (
        <li
            id={props.id}
            className={`quiz-card light ${props.first ? `first` : ``} ${
                props.last ? `last` : ``
            }`}
            style={props.style}
            onFocus={() => props.setCurrentStep(props.step)}
        >
            {props.id === `card-4` && <>{props.children}</>}
            {props.id !== `card-4` && (
                <>
                    <fieldset>
                        <legend>
                            <div className="sr-only">{props.mainHeading}</div>
                            {props.title}
                        </legend>
                        {props.children}
                    </fieldset>
                    <div className="nav">
                        {!props.first && (
                            <button
                                type="button"
                                role="presentation"
                                tabIndex={-1}
                                aria-label="Back"
                                onTouchStart={(e) => e.preventDefault()}
                                onClick={() => {
                                    (
                                        document.activeElement as HTMLElement
                                    ).blur();
                                    props.setCurrentStep((step) => step - 1);
                                }}
                            >
                                <KiteIcon
                                    icon="ki-arrow-left"
                                    size="1.25rem"
                                />
                            </button>
                        )}
                        {!props.last && (
                            <button
                                type="button"
                                role="presentation"
                                tabIndex={-1}
                                disabled={!props.valid}
                                onTouchStart={(e) =>
                                    e.cancelable && e.preventDefault()
                                }
                                onClick={() => {
                                    (
                                        document.activeElement as HTMLElement
                                    ).blur();
                                    props.setCurrentStep((step) => step + 1);
                                }}
                            >
                                Continue
                                <KiteIcon
                                    icon="ki-arrow-right"
                                    size="1.25rem"
                                />
                            </button>
                        )}
                        {props.last && (
                            <button type="submit" disabled={!props.valid}>
                                Finish
                                <KiteIcon
                                    icon="ki-arrow-right"
                                    size="1.25rem"
                                />
                            </button>
                        )}
                    </div>
                </>
            )}
        </li>
    );
};
